export default __webpack_public_path__ + "static/media/micro-atm.392421e0.png";